import { style } from 'd3';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { DrawSVGWedge, DrawSVGCircle } from 'src/app/model/drawing/primitives';
@Component({
  selector: 'app-angle-view',
  templateUrl: './angle-view.component.html',
  styleUrls: ['./angle-view.component.scss']
})
export class AngleViewComponent implements AfterViewInit {
  public center = { x: 100, y: 100 };
  public anglePt = { x: 0, y: 0 }
  public bearingPt = { x: 0, y: 0 }
  @ViewChild('view') view: ElementRef<SVGElement>;
  @ViewChild('circleUnderlay') circleUnderlay: ElementRef<SVGPathElement>;
  @ViewChild('wedge') wedge: ElementRef<SVGPathElement>;
  @ViewChild('circleOverlay') circleOverlay: ElementRef<SVGPathElement>;
  @ViewChild('angleLine') angleLine: ElementRef<SVGLineElement>;
  @ViewChild('bearingLine') bearingLine: ElementRef<SVGLineElement>;

  private _bearing: number = 0;
  @Input()
  set bearing(val: number) {
    if (this._bearing === val) return;
    this._bearing = val;
    this.UpdateWedge();
  };
  get bearing(): number {
    return this._bearing;
  }

  private _fromToDirection: 'from' | 'to' = 'from';
  @Input()
  public set fromToDirection(val: 'from' | 'to') {
    if (this._fromToDirection === val) return;
    this._fromToDirection = val;
    this.UpdateFromToStyles();
  }
  public get fromToDirection(): 'from' | 'to' {
    return this._fromToDirection;
  }
  private _angle: number = 45;
  @Input()
  set angle(val: number) {
    if (this._angle === val) return;
    this._angle = val;
    this.UpdateWedge();
  }
  get angle(): number {
    return this._angle;
  }
  public get symbolCenterX() {
    return this.center.x;
  }
  public get symbolCenterY() {
    return this.center.y;
  }
  public get angleX(): number {
    return this.anglePt.x;
  }
  public get angleY(): number {
    return this.anglePt.y;
  }
  public get bearingPtX(): number {
    return this.bearingPt.x;
  }
  public get bearingPtY(): number {
    return this.bearingPt.y;
  }
  public get angleSymbolX(): number {
    return this.angleX;
  }
  public get angleSymbolY(): number {
    return this.angleY;
  }


  public get bearingTransform() {
    return `rotate(${this.bearingPtAngle},${this.bearingPt.x},${this.bearingPt.y})`;
  }
  public bearingPtAngle = 0;
  public radius: number = 90;
  private fromColor: string = '';
  private toColor: string = '';
  constructor(private domNode: ElementRef, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {

    const compStyle = getComputedStyle(this.domNode.nativeElement);
    const [x, y] = compStyle.getPropertyValue('--center').trim().split(' ')
    this.fromColor = compStyle.getPropertyValue('--from-color');
    this.toColor = compStyle.getPropertyValue('--to-color');
    this.center.x = Number(x);
    this.center.y = Number(y);
    const radiusStyle = compStyle.getPropertyValue('--angle-radius');
    if (radiusStyle !== '') this.radius = Number(radiusStyle);
    console.log(this.center, this.radius);
    DrawSVGCircle(this.circleUnderlay.nativeElement, this.center, this.radius);
    DrawSVGCircle(this.circleOverlay.nativeElement, this.center, this.radius);

    this.UpdateWedge();
  }
  UpdateFromToStyles() {
    switch (this.fromToDirection) {
      case 'from':
        (this.domNode.nativeElement as HTMLElement).style.setProperty('--from-color', this.toColor);
        (this.domNode.nativeElement as HTMLElement).style.setProperty('--to-color', this.fromColor);
        break;
      case 'to':
        (this.domNode.nativeElement as HTMLElement).style.setProperty('--from-color', this.fromColor);
        (this.domNode.nativeElement as HTMLElement).style.setProperty('--to-color', this.toColor);
        break;

    }
  }
  UpdateWedge() {

    if (!this.wedge?.nativeElement) return;
    this.wedge.nativeElement.classList.toggle('negative', this.angle < 0);

    const params: any = DrawSVGWedge(this.wedge.nativeElement, this.radius, this.center, this.bearing, this.angle);
    if (params?.end) {
      this.anglePt = params.end;
    }
    if (params?.start) {
      this.bearingPt = params.start;
    }
    this.bearingPtAngle = this.bearing;
    this.cdr.markForCheck();
    this.cdr.detectChanges();

  }

}
